var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "n-sign-pad", class: _vm.readonly && "readonly" },
    [
      _c("span", { staticClass: "field-label primary--text" }, [
        _vm._v(_vm._s(_vm.label))
      ]),
      _c("canvas", { attrs: { id: "sign-pad" } }),
      _c(
        "a",
        {
          staticClass: "icon-clear",
          attrs: { title: "Clear Signature" },
          on: { click: _vm.clearPad }
        },
        [_c("v-icon", { attrs: { color: "primary" } }, [_vm._v("md_close")])],
        1
      ),
      _vm.checkValid && !_vm.isValid()
        ? _c("p", { staticClass: "error-message" }, [
            _vm._v("Bitte einen Wert angeben")
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }